import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

interface ErrorPageProps {
    code: number;
    title: string;
    message?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ code, title, message }) => {
    return (
        <div
            className="page_content"
            style={{
                minHeight: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--page-bg, #f5f6fa)",
                padding: 20,
            }}
        >
            <HelmetProvider>
                <Helmet title={title} />
            </HelmetProvider>

            <div
                className="admin-card"
                style={{
                    maxWidth: 560,
                    width: "100%",
                    textAlign: "center",
                    padding: "48px 40px",
                    animation: "fadeInUp 0.6s ease",
                }}
            >
                <div
                    style={{
                        fontSize: 96,
                        fontWeight: 800,
                        lineHeight: 1,
                        marginBottom: 16,
                        color: "var(--accent-main, #4c6ef5)",
                    }}
                >
                    {code}
                </div>

                <h1
                    style={{
                        fontSize: 26,
                        marginBottom: 12,
                        color: "#1f2937",
                    }}
                >
                    {title}
                </h1>

                <p
                    style={{
                        fontSize: 16,
                        color: "#6b7280",
                        marginBottom: 32,
                        lineHeight: 1.5,
                    }}
                >
                    {message ?? "Что-то пошло не так. Попробуйте вернуться на главную страницу."}
                </p>

                <a
                    href="/"
                    className="admin-button-primary"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        textDecoration: "none",
                        padding: "12px 24px",
                        fontSize: 16,
                    }}
                >
                    ← На главную
                </a>
            </div>

            <style>
                {`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                `}
            </style>
        </div>
    );
};

export default ErrorPage;
